import React from 'react'
import {
  List,
  Datagrid,
  ChipField,
  TextField,
  ReferenceManyField,
  SingleFieldList,
  UrlField,
  DateField,
} from 'admin-on-rest'

import { Link } from 'react-router-dom'

import { connect } from 'react-redux'

import FlatButton from 'material-ui/FlatButton'
import Dialog from 'material-ui/Dialog'

import { translate } from 'admin-on-rest'

import compose from 'recompose/compose'

import { StudentsCountField } from '../components/StudentsCountField'
import { dateParser } from '../helpers'

class InstructorCoursesList extends React.Component {
  state = {
    showDialogConfirmation: false,
    currentCourseId: null,
    currentCourse: null,
  }

  handleClose = () => {
    this.setState({
      showDialogConfirmation: false,
      currentCourseId: null,
      currentCourse: null,
    })
  }

  handleDialog(courseId) {
    this.props.handleAction(courseId)
    this.handleClose()
  }

  render() {
    const { translate } = this.props

    const dialogActions = [
      <FlatButton
        label={this.props.labelDialogCancel}
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label={this.props.labelDialogConfirm}
        primary={true}
        onClick={() => {
          this.props.handleAction(
            this.state.currentCourseId,
            this.state.currentCourse,
          )
        }}
      />,
    ]

    return (
      <div>
        <Dialog
          title={this.props.labelDialogTitle}
          actions={dialogActions}
          modal={false}
          open={this.state.showDialogConfirmation}
          onRequestClose={this.handleClose}
        >
          {this.props.labelDialogDescription}
        </Dialog>
        <List {...this.props} title={this.props.titleLabel}>
          <Datagrid key="id">
            <CourseTitle label="Denumire Curs" />
            <DateField label="Data curs" source="date" parse={dateParser} />
            <TextField label="Credite" source="credits" />
            <StudentsCountField label="Cursanti inscrisi" />
            <ReferenceManyField
              label="Lector"
              reference="instructors"
              target="courses"
              allowEmpty
            >
              <SingleFieldList>
                <ChipField source="displayName" />
              </SingleFieldList>
            </ReferenceManyField>
            {this.props.buttonActions.map((action, index) => (
              <ButtonAction
                action={action}
                index={index}
                key={index}
                label=""
                onClick={(courseId, course) => {
                  this.setState({
                    showDialogConfirmation: true,
                    currentCourseId: courseId,
                    currentCourse: course,
                  })
                }}
              />
            ))}
          </Datagrid>
        </List>
      </div>
    )
  }
}

const CourseTitle = ({ record }) => (
  <Link to={`course/instructor/${record.id}`}>{record.name}</Link>
)

const ButtonAction = ({ action, record, index, onClick }) => {
  // console.log('record', record)
  return (
    <FlatButton
      primary={action.primary}
      secondary={action.secondary}
      label={action.label}
      onClick={() => onClick(record.id, record)}
      key={index}
    />
  )
}

const enhance = compose(translate, connect(null, {}))

export default enhance(InstructorCoursesList)



// WEBPACK FOOTER //
// ./src/instructors/InstructorsCoursesList.js